// Export color definitions with both key and human-friendly name
export const COLOR_DEFINITIONS = [
    { key: "brand-primary-base", name: "brand-primary-base" },
    { key: "brand-primary-dark", name: "brand-primary-dark" },
    { key: "brand-primary-darker", name: "brand-primary-darker" },
    { key: "brand-primary-light", name: "brand-primary-light" },
    { key: "brand-primary-lighter", name: "brand-primary-lighter" },
    { key: "brand-primary-lightest", name: "brand-primary-lightest" },
    { key: "brand-secondary-base", name: "brand-secondary-base" },
    { key: "brand-secondary-darker", name: "brand-secondary-darker" },
    { key: "brand-secondary-light", name: "brand-secondary-light" },
    { key: "brand-secondary-lighter", name: "brand-secondary-lighter" },
    { key: "brand-secondary-lightest", name: "brand-secondary-lightest" },
    // { key: "error-base", name: "error-base" },
    // { key: "error-lighter", name: "error-lighter" },
    // { key: "neutrals-base", name: "neutrals-base" },
    // { key: "neutrals-lighter", name: "neutrals-lighter" },
    // { key: "neutrals-lightest", name: "neutrals-lightest" },
    // { key: "neutrals-darker", name: "neutrals-darker" },
    // { key: "neutrals-darkest", name: "neutrals-darkest" },
    // { key: "neutrals-light", name: "neutrals-light" }
];

export const getDefaultWhitelabelConfiguration = (affiliateCode) => ({
    schemaVersion: "1.0.0",
    siteName: "",
    domains: [
        ""
    ],            // e.g. ["example.com"]
    affiliateCode,

    favicon: "",
    logo: "",

    enableCoupons: false,

    header: {
        backgroundColor: "",  // e.g. "#ffffff"
        height: "",           // e.g. "64px"
        showHomeLink: true,
        useDarkFont: true,
        returnUrls: [
            { locale: "en", url: "", label: "" },
        ],
    },

    head: [
        {
            locale: "en",
            title: "",
            description: "",
            meta: {
                robots: "",
                og: { title: "", description: "", image: "" },
            },
        }
    ],

    cta: {
        fontColor: "",
        radius: "",
    },

    footer: {
        backgroundColor: "",
        useDarkFont: true,
        links: [],
    },

    searchMask: {
        backgroundColor: "",
        hideFilters: false,
        infoSectionFontColorWhite: false,
        popularPorts: [],
        backgroundImage: "",
    },

    showPoweredBy: true,

    colors: COLOR_DEFINITIONS.map(def => ({ key: def.key, value: '' })),

    localization: {
        languages: ["en", "es", "de", "fr", "it"],
        currencies: ["EUR", "USD", "GBP", "AUD", "CAD"],
        defaultLanguage: "en",
        defaultCurrency: "EUR",
    },

    social: {
        facebook: "",
        tiktok: "",
        instagram: "",
        linkedin: "",
        x: "",
    },

    communication: {
        email: {
            fromEmail: "",
            fromName: "",
            replyToEmail: "",
            replyToName: "",
            bccEmails: [],
            localizedSubjects: [],
        },
    },

    thirdPartyTrackers: {
        googleAnalytics: { enabled: false, id: "" },
        cookieBot: { enabled: false, id: "" },
        googleTagManager: { enabled: false, id: "" },
    },
});
